import {
  CreateLeadResponse,
  LeadB2CPayload,
} from '@/services/api/MarketingApiTypes';
import type { FormSortContactDetails } from '@/types/forms';
import type { TrackingData } from '@/utils/tracking';

export class LeadCreationService {
  private contactDetails: FormSortContactDetails;
  private trackingData: TrackingData;

  constructor(
    contactDetails: FormSortContactDetails,
    trackingData: TrackingData
  ) {
    this.contactDetails = contactDetails;
    this.trackingData = trackingData;
  }

  private buildPayload(): LeadB2CPayload {
    return {
      firstName: this.contactDetails.first_name,
      lastName: this.contactDetails.last_name,
      email: this.contactDetails.email_address,
      phoneNumber: this.contactDetails.phone_number,
      zipCode: this.contactDetails.postal_code,
      type: 'Individual/Family Member',
      lead_channel: 'Website Form',
      opportunity_type: 'New Membership',
      company: `${this.contactDetails.first_name}, ${this.contactDetails.last_name} Famliy`,
      submissionUrl: this.trackingData.submission_url,
      leadSource: 'Website',
      utm_source: this.trackingData.utm_source,
      utm_medium: this.trackingData.utm_medium,
      utm_term: this.trackingData.utm_term,
      utm_campaign: this.trackingData.utm_campaign,
      utm_content: this.trackingData.utm_content,
      campaignId: this.trackingData.campaignId,
      templateId: this.trackingData.templateId,
      gclid: this.trackingData.gclid,
      msclkid: this.trackingData.msclkid,
      fbclid: this.trackingData.fbclid,
      ours_device_id: this.trackingData.ours_device_id,
      vwo_uuid: this.trackingData.vwo_uuid,
      source_details: 'Web Lead',
      membership_type: '',
      ContactUsType: 'General',
      sms_opt_in: this.contactDetails.sms_opt_in,
    };
  }

  private async postLead(payload: LeadB2CPayload): Promise<CreateLeadResponse> {
    const res = await fetch('/api/create-lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errorText = await res.text().catch(() => '');

      console.error('Request failed:', {
        status: res.status,
        message: errorText,
      });

      throw new Error('Something went wrong. Please try again later.');
    }

    return await res.json();
  }

  async createLead(): Promise<CreateLeadResponse> {
    const payload = this.buildPayload();

    return await this.postLead(payload);
  }
}
